import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { DebugService } from './shared/services/debug.service.js';
import { SessionService } from './core/services/session/session.service.js';
import { ApiService } from './core/services/api/api.service.js';
import { REFI_VEHICLE_LOAN_CONST } from './shared/constants/app.constants.js';
import { CookieService } from './core/services/cookie/cookie.service.js';
import { ApplicationService } from './services/application.service.js';
import { stratum } from '../constants/stratum.js';

class _AppService {
  constructor() {
    this.debug = new DebugService('AppService');
    this.session = SessionService.session || {};
  }

  saveVehicleLoanPrequalInfo(prequalObj) {
    this.debug.log('save vehicle loan info with', prequalObj);
    const headers = REFI_VEHICLE_LOAN_CONST.HTTP_HEADERS;
    const { firstName, lastName, dateOfBirth, emailAddress } =
      ApplicationService.applicant;
    const customerDetails = {
      firstName,
      lastName,
      dateOfBirth,
      emailAddress,
    };
    const savePrequalObject = { ...prequalObj, customerDetails };
    headers.ProfileReferenceId = CookieService.getCookie('C1_PRID');
    return ApiService.post(
      REFI_VEHICLE_LOAN_CONST.SAVE_VEHICLE_AND_LOAN_INFO_URL(),
      savePrequalObject,
      headers
    ).then(
      () => {
        this.debug.log('save vehicle loan info call success');
        stratum.publishTag(
          ApplicationService.isInAppDeclineDelayOn
            ? TagKey.REFI_LEADS_VEHICLE_LEADS_SAVE_2
            : TagKey.REFI_LEADS_VEHICLE_LEADS_SAVE
        );
      },
      (err) => {
        this.debug.log('save vehicle loan info call failed ', err);
        return new Error('call_failed');
      }
    );
  }

  get testingParam() {
    return this._testingParam;
  }

  set testingParam(param) {
    const lighthouseKey = Object.keys(
      REFI_VEHICLE_LOAN_CONST.LIGHTHOUSE_QUERY_PARAM
    ).find(
      (key) =>
        REFI_VEHICLE_LOAN_CONST.LIGHTHOUSE_QUERY_PARAM[key].paramValue === param
    );
    if (param && lighthouseKey) {
      this._testingParam = lighthouseKey;
    }
  }
}

export const AppService = new _AppService();
